import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useWatchUpdateEffect from '@src/libs/hooks/useWatchUpdateEffect';
import { useActions } from '@src/containers/Session/hooks';
import { loadSpacesParams } from '../selectors/loadSpacesParams';
import loadSpacesAction from '../reducers/loadSpaces';

export const useLoadSpaces = () => {
	const dispatch = useDispatch();

	const loadSpaces = React.useCallback(
		(params) => {
			return dispatch(loadSpacesAction.action({ params }));
		},
		[dispatch],
	);

	return {
		loadSpaces,
	};
};

export const useLoadSpacesWatcher = () => {
	const { loadSpaces } = useLoadSpaces();
	const { setGlobalLoading } = useActions();
	const params = useSelector(loadSpacesParams);

	useWatchUpdateEffect(() => {
		setGlobalLoading({ isLoading: true });
		const res = loadSpaces(params);
		res.finally(() => {
			setGlobalLoading({ isLoading: false });
		});
		return () => {
			res.abort();
		};
	}, [params]);
};
